import { Props } from ".../../../types/field";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  getDataTableRequest,
} from "../../../users/states/action";
import { useSelector } from "react-redux";
import { Button, Divider, Drawer, Typography } from "antd";
import ReportFilter from "./reportFilter/reportFilter";

const { Text } = Typography;

const DynamicReports: React.FC<Props> = () => {
  
  const dispatch = useDispatch();
  const rootState = useSelector((state: any) => state?.userReducer);
  let {
    userDataTable: { data: columnData },
  } = rootState || {};
  const [open, setOpen] = useState(false);
  const [reportUrl, setReportUrl] = useState();
  const [reportFilterTitle, setreportFilterTitle] = useState();
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    dispatch(
      getDataTableRequest({
        api: "insights/platform/view/api/vw-report-list?size=500&page=0",
      })
    );
  }, [open]);

  return (
    <div>
      <Drawer
        className=""
        title={reportFilterTitle}
        placement="right"
        onClose={() => onClose()}
        destroyOnClose={true}
        open={open}
      >
        <ReportFilter
          onClose={onClose}
          open={open}
          bluePrintApi={reportUrl}
        />
      </Drawer>
      <div className="ml-2 mt-2">
        <Text className="text-primary font-medium text-2xl mt-3 ml-2">Dynamic Reports</Text>
        <div style={{ width: "70%" }} className="ml-3 mt-5">
          {columnData?.records?.map((records: any, index:number) => (<>
            <div className="my-3 justify-content-between" key={records.id}>

              <div className="text-base font-normal pt-1">
              {index+1 + ". "}{records.reportName}
              </div>

              <div>
                <Button type="default"  onClick={() => {
                  showDrawer()
                  setReportUrl(records.bluePrintName)
                  setreportFilterTitle(records.reportName)
                }}> Generate </Button>
              </div>
            </div>

             {(index+1 < columnData.records.length) && <Divider/>}
          </>

          ))}
        </div>
      </div>
    </div>
  );
};

export default DynamicReports;
